import React, { useMemo, useState } from 'react';

import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import { Small, Span } from '../../../components/Typography';
import { Link } from "react-router-dom";

import { getStatus } from '../../../utils/misc';
import { getCordAddress, useGetOrderStatusByOrderId, useUpdateOrder } from '../../../requests/order';
import { useCustomerById } from '../../../requests/customer';
import { Avatar, Button, Input, message, Modal, Tag } from 'antd';
import { getBaseUrl } from '../../../../config/base-url';

const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px !important',
    background: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    '& small': { color: theme.palette.text.secondary },
    '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main },
}));

const Heading = styled('h6')(({ theme }) => ({
    margin: 0,
    marginTop: '2px',
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.primary.main,
}));



const OrderDetailTopCards = ({ order, loadData }) => {

    const [editOpen, setEditOpen] = useState(false);
    const [editForm, setEditForm] = useState({});

    const { data: statusResponse } = useGetOrderStatusByOrderId(order.id);
    const { data: customerData } = useCustomerById(order?.user_id);
    const { mutate: updateOrder, isLoading: updating } = useUpdateOrder();

    // console.log('cust data', customerData);

    const [cordAddress, setCordAddress] = useState('')
    useMemo(() => {
        (async () => {
            try {
                if (order) {
                    const { latitude, longitude } = order;
                    if (latitude && longitude) {
                        const addr = await getCordAddress({ lat: latitude, lng: longitude })
                        setCordAddress(addr);
                    }
                }
            } catch (error) {
            }
        })()
    }, [order]);



    function printInvoice() {
        window.open(`${getBaseUrl()}/api/orders/single-invoice-print/${order.id}`)

    }


    return (
        <Grid container spacing={3}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">confirmation_number</Icon>
                        <Box ml="12px">
                            <Small>Order No.</Small>
                            <Heading>ORD{order.id}</Heading>
                            <Small> Date: {new Intl.DateTimeFormat('en-GB', { dateStyle: 'full', timeStyle: 'short', hour12: true, timeZone: "Asia/Dhaka" }).format(new Date(parseInt(`${order.ordered_at}`)))}</Small>
                        </Box>
                    </ContentBox>
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">directions_bike</Icon>
                        <Box ml="12px">
                            <Small>Rider</Small>
                            <Heading>{order.rider !== undefined && order.rider !== null ? order.rider.name ?? "No Name" : "No Rider"}</Heading>
                            <Small> {order.rider !== undefined && order.rider !== null ? order.rider.phone ?? "No Name" : "No Rider"}</Small>
                        </Box>
                    </ContentBox>

                    {
                        order.rider && <Tooltip title="View Rider" placement="top">
                            <Link to={'/rider_detail/' + order.rider?.id}>
                                <IconButton>
                                    <Icon>arrow_right_alt</Icon>
                                </IconButton>
                            </Link>
                        </Tooltip>
                    }
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <Link to={"/customer/" + order.user_id}>
                    <StyledCard elevation={6}>
                        <ContentBox>
                            {customerData && customerData?.image ? <>
                                <Avatar src={customerData?.image} />
                            </> : <Icon className="icon">assignment_ind</Icon>}
                            <Box ml="12px">
                                <Small>Customer</Small>
                                <Heading>{customerData?.first_name} {customerData?.last_name}</Heading>
                                {/* <Small>{order.phone}</Small> */}
                                {customerData?.phone && !order.phone && <Small>{customerData?.phone}</Small>}
                            </Box>


                        </ContentBox>

                        <Tooltip title="View Details" placement="top">
                            <Link to={"/customer/" + order.user_id}>
                                <IconButton>
                                    <Icon>arrow_right_alt</Icon>
                                </IconButton>
                            </Link>
                        </Tooltip>

                        {/* <Small>
                            <span>Email: {customerData?.email ? customerData?.email : 'N/A'}</span> <br />
                            <span>Shipping Address:
                                {order?.vendor?.mart_id === 1 ? `${order?.address}, ${order?.area}, ${order?.city}, ${order?.province}` : ""}

                                {order?.vendor?.mart_id === 1 ? "" : cordAddress}</span></Small> */}
                    </StyledCard>
                </Link>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <Link to={"/customer/" + order.user_id}>
                    <StyledCard elevation={6}>
                        <ContentBox>
                            <Icon className="icon">local_shipping</Icon>
                            <Box ml="12px">
                                <Small>Shipping Address</Small>
                                <Heading>{order?.full_name}</Heading>
                                <Small>{order?.phone}</Small>
                            </Box>
                        </ContentBox>

                        <Small>
                            <span>Email: {order?.email ? order?.email : 'N/A'}</span> <br />
                            <span>Shipping Address:
                                <Small>{order.address}, {order.area}, {order.city}, {order.province}</Small></span>
                        </Small>

                        {order?.note && (
                            <Small>
                                <br />
                                <span>Order Note: <Small>{order.note}</Small></span>
                            </Small>
                        )}

                        <Tooltip title="Edit Shipping Address" placement="top">
                            <IconButton onClick={e => { e.preventDefault(); setEditForm({ full_name: order.full_name, phone: order.phone, email: order.email, province: order.province, city: order.city, area: order.area, address: order.address }); setEditOpen(true); }}>
                                <Icon>edit</Icon>
                            </IconButton>
                        </Tooltip>
                    </StyledCard>
                </Link>

                <Modal
                    title="Edit Shipping Address"
                    open={editOpen}
                    onCancel={() => setEditOpen(false)}
                    okText="Save"
                    confirmLoading={updating}
                    onOk={() => {
                        updateOrder({ id: order.id, ...editForm }, {
                            onSuccess: () => {
                                message.success('Shipping address updated');
                                setEditOpen(false);
                                loadData();
                            },
                            onError: (err) => {
                                message.error(err?.message || 'Update failed');
                            }
                        })
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <Input addonBefore="Full Name" value={editForm.full_name} onChange={e => setEditForm({ ...editForm, full_name: e.target.value })} />
                        <Input addonBefore="Phone" value={editForm.phone} onChange={e => setEditForm({ ...editForm, phone: e.target.value })} />
                        <Input addonBefore="Email" value={editForm.email} onChange={e => setEditForm({ ...editForm, email: e.target.value })} />
                        <Input addonBefore="Province" value={editForm.province} onChange={e => setEditForm({ ...editForm, province: e.target.value })} />
                        <Input addonBefore="City" value={editForm.city} onChange={e => setEditForm({ ...editForm, city: e.target.value })} />
                        <Input addonBefore="Area" value={editForm.area} onChange={e => setEditForm({ ...editForm, area: e.target.value })} />
                        <Input addonBefore="Address" value={editForm.address} onChange={e => setEditForm({ ...editForm, address: e.target.value })} />
                    </div>
                </Modal>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">store_front</Icon>
                        <Box ml="12px">
                            <Small>Seller</Small>
                            <Heading>{order?.vendor?.shop_name}</Heading>
                            <Small>{order?.vendor?.phone}</Small>
                        </Box>
                    </ContentBox>

                    <Tooltip title="View Details" placement="top">
                        <Link to={'/seller_detail/' + order.seller_id}>
                            <IconButton>
                                <Icon>arrow_right_alt</Icon>
                            </IconButton>
                        </Link>
                    </Tooltip>

                    <Small>Address: {order?.vendor?.address}, {order?.vendor?.area} {order?.vendor?.district}, {order?.vendor?.division}</Small>
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">diamond</Icon>
                        <Box ml="12px">
                            <Small>Order Status</Small>
                            <Heading>
                                {statusResponse && getStatus(statusResponse?.event)}
                            </Heading>

                            {order?.cancel_reason &&
                                <div style={{
                                    padding: "10px 0px",
                                }}>
                                    <span style={{ fontSize: 12 }}>{order?.cancel_reason}</span>
                                </div>
                            }

                            {order?.cancel_by &&
                                <span style={{ fontSize: 12 }}>
                                    <Tag>cancel By:</Tag>  {order?.cancel_by}
                                </span>
                            }
                        </Box>
                    </ContentBox>
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">payment</Icon>
                        <Box ml="12px">
                            <Small>Payment Method</Small>
                            <Heading>
                                {
                                    String(order.payment_method.toUpperCase()).toLowerCase() === "none" ?
                                        "Waiting for payment" :
                                        order.payment_method.toUpperCase()
                                }
                            </Heading>
                        </Box>
                    </ContentBox>
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        <Icon className="icon">payment</Icon>
                        <Box ml="12px">
                            <Small>Source</Small>
                            <Heading>
                                {
                                    String(order?.plateform?.toUpperCase())
                                }
                            </Heading>
                        </Box>
                    </ContentBox>
                </StyledCard>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
                <StyledCard elevation={6}>
                    <ContentBox>
                        {/* <Icon className="icon">printer</Icon> */}
                        <Box ml="12px">
                            <Button onClick={printInvoice}>Print Invoice</Button>
                        </Box>
                    </ContentBox>
                </StyledCard>
            </Grid>
        </Grid>
    );
};

export default OrderDetailTopCards;
